import moment from "moment";
import Modal from "../../../components/modal";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import React, { useRef } from "react";

const QuotationDetailModel = ({ show, onClose, heading, initialData = {} }) => {
    const company = JSON.parse(localStorage.getItem('company'));
    const pdfRef = useRef();

    const generateWeek = (date) => {
        return moment(date).add(6, 'weeks').format('DD MMMM, YYYY');
    };

    const getPaymentTerms = (terms) => {
        try {
            const parsedTerms = JSON.parse(terms);
        
            return (
                <ul style={{
                    listStyle: 'none',
                    paddingLeft: "0px"
                }}>
                    {parsedTerms && parsedTerms.map((e, index) => (
                        <li key={index}>{e.terms}</li>
                    ))}
                </ul>
            );
        } catch (error) {
            return terms || "N/A";
        }
    };

    const downloadPDF = () => {
        const input = pdfRef.current;
        html2canvas(input, { scale: 4 }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4");
            const imgWidth = 210;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            pdf.addImage(imgData, "PNG", 0, 20, imgWidth, imgHeight);
            pdf.save("quotation.pdf");
        });
    };
    
    const generateDetails = (extras) => {
        
        const ext = extras?JSON.parse(extras):[];

    
        return (
            <ul >
                {ext.map((e, index) => (
                    <li key={index}>{e.description} - ₹{e.amount}</li>
                ))}
            </ul>
        );
    };
    
    
    return (
        <Modal show={show} onClose={onClose} heading={heading}>
            <button onClick={downloadPDF} style={{ position: "absolute", top: 10, right: 10, padding: "5px 10px", background: "#007bff", color: "#fff", border: "none", cursor: "pointer" }}>Download PDF</button>
            <div ref={pdfRef} id="quoteDetail" className="container">
                <div className="header mt-3">
                    <h2 style={{
                        marginTop: '20px'
                    }}>{company?.company?.company_name}</h2>
                    <small style={{ wordWrap: "break-word", overflowWrap: "break-word", whiteSpace: "normal" }}>{company?.company?.nature_of_business}</small><br />
                    <small style={{wordWrap: "break-word", overflowWrap: "break-word", whiteSpace: "normal" }}>ISO 9001, 2001 CERTIFIED COMPANY</small><br />
                    <small>Office -  {company?.company?.register_address}</small><br />
                    <small>GSTIN NO. -  {company?.company?.gst_number}</small>
                </div>
                <hr />

                <div className="details">
                    <div className="row">
                    
                        <div className="col-md-3"></div>
                        <div className="col-md-6">
                            <h4 style={{
                                textAlign: "center"
                            }}>Revised Quotation</h4>
                        </div>
                        <div className="col-md-3 text-end">
                            <p>Date: {moment(initialData?.updatedAt).format('DD.MM.YYYY')}</p>
                        </div>
                        
                    </div>
                    <p><strong>To:</strong> {initialData?.customer?.company_name}</p>
                    <p><strong>RFQ No.:</strong> {initialData?.tenderId}</p>
                    <p><strong>Delivery Date:</strong> {moment(initialData?.date).format('DD MMMM, YYYY')}</p>
                    <p><strong>Kind Attn.:</strong> Mr.</p>
                </div>

                <table>
                    <thead>
                        <tr>
                            <th>Item Code</th>
                            <th>Item Description</th>
                            <th>Qty.</th>
                            <th>Rate (Each)</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr >
                            <td className="m-2">{initialData?.finalProduct?.sku}</td>
                            <td width={"50%"}>{initialData?.finalProduct?.name} <br/>{initialData?.item_description} <br/> {generateDetails(initialData?.extra_amounts)}</td>
                            <td className="m-2">{initialData?.quantity} No.</td>
                            <td className="m-2">₹ {initialData?.final_cost}</td>
                            <td className="m-2">₹ {initialData?.final_cost}</td>
                        </tr>
                    </tbody>
                </table>

                <div className="terms">
                    <h5>Terms & Conditions</h5>
                    <table>
                        <tr>
                            <td width={"30%"}>Price Basis: </td>
                            <td width={"30%"}>FOR - {initialData?.customer?.company_name}</td>
                        </tr>
                        <tr>
                            <td width={"30%"}>Freight: </td>
                            <td width={"30%"}>{initialData?.freight === 1 ? "Included" : "Excluded"}</td>
                        </tr>
                        <tr>
                            <td width={"30%"}>Delivery: </td>
                            <td width={"30%"}>{initialData?.is_show_delivery ? generateWeek(initialData?.proposed_delivery_date) : moment(initialData?.proposed_delivery_date).format('DD MMMM, YYYY')}</td>
                        </tr>
                        <tr>
                            <td width={"30%"}>Payment Terms: </td>
                            <td width={"30%"}>{getPaymentTerms(initialData?.payment_terms)}</td>
                        </tr>
                        <tr>
                            <td width={"30%"}>Warranty: </td>
                            <td width={"30%"}>{initialData?.guarantee}</td>
                        </tr>
                    </table>
                </div>
                <div className="text-start mt-5">
                    <small>We are Waiting for your Valuable Order</small><br />
                    <small>Thanking you</small><br />
                    <small>Your faithfully,</small>
                </div>
                <div className="text-start mt-5">
                    <small>For {company?.company?.company_name}</small><br />
                    <small><strong>{company?.company?.user_name}</strong></small><br />
                    <small>Contact: {company?.company?.mobile_no}</small>
                </div>
            </div>
        </Modal>
    );
};

export default QuotationDetailModel;
